import './SignUp.scss';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SocialMedia from '../../components/SocialMedia/SocialMedia';
import { setOriginDomainCustom } from '../../utils/GenericFunctions';

import StepHeader from '../../components/Wizard/StepHeader';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import RedirectSignIn from '../SignUpNativo/RedirectSignIn';
import Separator from '../../components/Separator';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';

export interface SignUpProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUp({
  nextPath,
  handleChangeStep,
  context
}: SignUpProps) {
  const { setValue, originDomainForm } = useContext<any>(context);
  const navigate = useNavigate();

  const { setControllerViews } = useControllerFlowStepsContext();

  useEffect(() => {
    setOriginDomainCustom();
  }, []);

  useEffect(() => {
    sessionStorage.clear();
    setControllerViews({});
    if (originDomainForm) {
      setValue('provider', '');
      setValue('socialId', '');
      const url = `/${originDomainForm}/criar-conta`;
      navigate(url, { replace: true });
    }
  }, [originDomainForm]);

  function handleSignUpNative() {
    const url =
      originDomainForm === 'signup'
        ? '/signup/criar-conta/nome'
        : originDomainForm === 'sbt/signup'
          ? '/sbt/signup/criar-conta/nome'
          : '/videos/signup/criar-conta/nome';
    navigate(url);

    if (nextPath) handleChangeStep(nextPath);
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Vem pra cá"
          description={[
            'Você pode criar sua Conta SBT usando um login social ou informando seus dados.',
            'Como você quer continuar?'
          ]}
        />

        <SocialMedia context={context} />

        <Separator text="ou" />

        <Button
          customColors="btn-primary"
          aria-label="Continuar com e-mail e senha"
          onClick={handleSignUpNative}
        >
          <ButtonLabel>Informar meus dados</ButtonLabel>
        </Button>
      </div>

      <RedirectSignIn context={context} />
    </div>
  );
}
